import { get, noop, map, findIndex, isUndefined, includes } from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { InlineIcon } from '../inline-icon/inline-icon';
import { Popover } from '../popover/popover';
import ArrowDownIcon from '../../icons/compiled/components/ArrowDownIcon';
import styles from './dropdown.scss';
import { KEY_CODES } from '../../widget/constants/key-codes';
export const OptionShape = PropTypes.shape({
    // TODO remove;
    // @ts-expect-error
    label: PropTypes.string.isRequred,
    // @ts-expect-error
    value: PropTypes.string.isRequred,
    className: PropTypes.string,
});
export class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.handleOptionKeyDown = (option) => (event) => {
            if (includes([KEY_CODES.SPACE, KEY_CODES.ENTER], event.keyCode)) {
                event.preventDefault();
                this.props.onChange(option);
                return;
            }
            const { previousElementSibling, nextElementSibling } = event.target;
            if (KEY_CODES.UP === event.keyCode) {
                event.preventDefault();
                if (previousElementSibling) {
                    previousElementSibling.focus();
                }
            }
            if (KEY_CODES.DOWN === event.keyCode) {
                event.preventDefault();
                if (nextElementSibling) {
                    nextElementSibling.focus();
                }
            }
        };
        this.setValue = (option) => () => {
            this.props.onChange(option);
        };
        this.saveOptionsRef = (ref) => (this.optionsRef = ref);
        this.renderOption = (option, key) => {
            const { optionClassName, selectedOptionClassName, selectedOption } = this.props;
            const isSelected = get(selectedOption, 'value') === option.value;
            return (React.createElement("section", { key: key, className: classnames(optionClassName, {
                    [selectedOptionClassName]: isSelected,
                }), role: "option", "aria-selected": isSelected, tabIndex: this.state.isOpen ? 0 : -1, "data-selected": isSelected, "data-hook": isUndefined(key) ? '' : 'dropdown-option', onKeyDown: this.handleOptionKeyDown(option), onMouseDown: this.setValue(option) }, option.label));
        };
        this.setIsOpen = (isOpen) => {
            this.setState({ isOpen }, () => {
                const { selectedOption, options, onToggle } = this.props;
                if (this.optionsRef) {
                    const optionNode = this.optionsRef.childNodes[findIndex(options, { value: selectedOption.value })];
                    if (optionNode) {
                        optionNode.focus();
                    }
                }
                onToggle(isOpen);
            });
        };
        this.state = {
            isOpen: false,
        };
    }
    renderOptions() {
        const { optionsContainerClassName, options } = this.props;
        return (React.createElement("div", { ref: this.saveOptionsRef, className: optionsContainerClassName }, map(options, this.renderOption)));
    }
    render() {
        const { selectedOption, className, openerClassName, valueClassName, arrowClassName, popoverClassName, arrowIcon, dataHook, ariaLabel, placeholder, isOpen, isRTL, } = this.props;
        const containerClass = classnames(styles.container, className, {
            [styles.isOpen]: this.state.isOpen,
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        const valueClass = classnames(styles.value, valueClassName);
        const arrowClass = classnames(styles.arrow, arrowClassName);
        return (React.createElement(Popover, { ariaRole: "combobox", isOpen: isOpen, ariaLabel: ariaLabel, className: popoverClassName, openerClassName: openerClassName, focusContentOnOpen: false, dataHook: dataHook, onToggle: this.setIsOpen, content: this.renderOptions(), dropdownPosition: isRTL ? 'left' : 'right' },
            React.createElement("div", { className: containerClass },
                React.createElement("div", { "data-hook": "dropdown-value", className: valueClass }, selectedOption ? selectedOption.label : placeholder),
                React.createElement(InlineIcon, { className: arrowClass, icon: arrowIcon }))));
    }
}
Dropdown.defaultProps = {
    onChange: noop,
    onToggle: noop,
    arrowIcon: React.createElement(ArrowDownIcon, null),
    placeholder: '',
    dataHook: 'dropdown-control',
};
//# sourceMappingURL=dropdown.js.map